//缺2、U型
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmyUShapeGapH(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc, 
  xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,
  x = param.x0, r = param.r, d = param.d, h = param.h,hd=h-r,glassH=param.glassH,glassW=param.glassW,  
  cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius;
           
if(glassW*1<glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xa, ya], [xa, ya-hd]),
                        BottomArc: new makerjs.paths.Arc([xa, ya-hd],[xa+d, ya-hd], r, true,false),
                        Right: new makerjs.paths.Line([xa+d, ya-hd], [xa+d, ya]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xa, ya+cutLine], [xa, ya]),
                        Left: new makerjs.paths.Line([xa, ya], [xa, ya-hd]),
                        BottomArc: new makerjs.paths.Arc([xa, ya-hd],[xa+d, ya-hd], r, true,false),
                        Right: new makerjs.paths.Line([xa+d, ya-hd], [xa+d, ya]),
                        Exline: new makerjs.paths.Line([xa+d, ya], [xa+d, ya+cutLine]),
                  }
            };
          } else if (area == "B") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xb, yb], [xb, yb-hd]),
                        BottomArc: new makerjs.paths.Arc([xb, yb-hd],[xb+d, yb-hd], r, true,false),
                        Right: new makerjs.paths.Line([xb+d, yb-hd], [xb+d, yb]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xb, yb+cutLine], [xb, yb]),
                        Left: new makerjs.paths.Line([xb, yb], [xb, yb-hd]),
                        BottomArc: new makerjs.paths.Arc([xb, yb-hd],[xb+d, yb-hd], r, true,false),
                        Right: new makerjs.paths.Line([xb+d, yb-hd], [xb+d, yb]),
                        Exline: new makerjs.paths.Line([xb+d, yb], [xb+d, yb+cutLine]),
                  }
            };
          } else if (area == "C") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xc-d, yc], [xc-d, yc-hd]),
                        BottomArc: new makerjs.paths.Arc([xc-d, yc-hd],[xc, yc-hd], r, true,false),
                        Right: new makerjs.paths.Line([xc, yc-hd], [xc, yc]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xc-d, yc+cutLine], [xc-d, yc]),
                        Left: new makerjs.paths.Line([xc-d, yc], [xc-d, yc-hd]),
                        BottomArc: new makerjs.paths.Arc([xc-d, yc-hd],[xc, yc-hd], r, true,false),
                        Right: new makerjs.paths.Line([xc, yc-hd], [xc, yc]),
                        Exline: new makerjs.paths.Line([xc, yc], [xc, yc+cutLine]),
                  }
            };
          } else if (area == "G") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xg, yg], [xg, yg+hd]),
                        BottomArc: new makerjs.paths.Arc([xg, yg+hd],[xg+d, yg+hd], r, true,true),
                        Right: new makerjs.paths.Line([xg+d, yg+hd], [xg+d, yg]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xg, yg-cutLine], [xg, yg]),
                        Left: new makerjs.paths.Line([xg, yg], [xg, yg+hd]),
                        BottomArc: new makerjs.paths.Arc([xg, yg+hd],[xg+d, yg+hd], r, true,true),
                        Right: new makerjs.paths.Line([xg+d, yg+hd], [xg+d, yg]),
                        Exline: new makerjs.paths.Line([xg+d, yg], [xg+d, yg-cutLine]),
                  }
            };
          } else if (area == "H") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xh, yh], [xh, yh+hd]),
                        BottomArc: new makerjs.paths.Arc([xh, yh+hd],[xh+d, yh+hd], r, true,true),
                        Right: new makerjs.paths.Line([xh+d, yh+hd], [xh+d, yh]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xh, yh-cutLine], [xh, yh]),
                        Left: new makerjs.paths.Line([xh, yh], [xh, yh+hd]),
                        BottomArc: new makerjs.paths.Arc([xh, yh+hd],[xh+d, yh+hd], r, true,true),
                        Right: new makerjs.paths.Line([xh+d, yh+hd], [xh+d, yh]),
                        Exline: new makerjs.paths.Line([xh+d, yh], [xh+d, yh-cutLine]),
                  }
            };
          } else if (area == "I") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xi-d, yi], [xi-d, yi+hd]),
                        BottomArc: new makerjs.paths.Arc([xi-d, yi+hd],[xi, yi+hd], r, true,true),
                        Right: new makerjs.paths.Line([xi, yi+hd], [xi, yi]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xi-d, yi-cutLine], [xi-d, yi]),
                        Left: new makerjs.paths.Line([xi-d, yi], [xi-d, yi+hd]),
                        BottomArc: new makerjs.paths.Arc([xi-d, yi+hd],[xi, yi+hd], r, true,true),
                        Right: new makerjs.paths.Line([xi, yi+hd], [xi, yi]),
                        Exline: new makerjs.paths.Line([xi, yi], [xi, yi-cutLine]),
                  }
            };
          }
}else{
      console.log("短边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myUShapeGapH = {
                  paths: {
                        Left: new makerjs.paths.Line([xa, ya], [xa+hd, ya]),
                        BottomArc: new makerjs.paths.Arc([xa+hd, ya],[xa+hd, ya-d], r, true,true),
                        Right: new makerjs.paths.Line([xa+hd, ya-d], [xa, ya-d]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                        EnLine: new makerjs.paths.Line([xa-cutLine, ya], [xa, ya]),
                        Left: new makerjs.paths.Line([xa, ya], [xa+hd, ya]),
                        BottomArc: new makerjs.paths.Arc([xa+hd, ya],[xa+hd, ya-d], r, true,true),
                        Right: new makerjs.paths.Line([xa+hd, ya-d], [xa, ya-d]),
                        Exline: new makerjs.paths.Line([xa, ya-d], [xa-cutLine, ya-d]),
                  }
            };
          } else if (area == "D") {
            var myUShapeGapH = {
                  paths: {
                      Left: new makerjs.paths.Line([xd, yd+r], [xd+hd, yd+r]),
                      BottomArc: new makerjs.paths.Arc([xd+hd, yd+r],[xd+hd, yd-d+r], r, true,true),
                      Right: new makerjs.paths.Line([xd+hd, yd-d+r], [xd, yd-d+r]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                      EnLine: new makerjs.paths.Line([xd-cutLine, yd+r], [xd, yd+r]),
                      Left: new makerjs.paths.Line([xd, yd+r], [xd+hd, yd+r]),
                      BottomArc: new makerjs.paths.Arc([xd+hd, yd+r],[xd+hd, yd-d+r], r, true,true),
                      Right: new makerjs.paths.Line([xd+hd, yd-d+r], [xd, yd-d+r]),
                      Exline: new makerjs.paths.Line([xd, yd-d+r], [xd-cutLine, yd-d+r]),
                  }
            };
          } else if (area == "C") {
            var myUShapeGapH = {
                  paths: {
                      Left: new makerjs.paths.Line([xc, yc], [xc-hd, yc]),
                      BottomArc: new makerjs.paths.Arc([xc-hd, yc],[xc-hd, yc-d], r, true,false),
                      Right: new makerjs.paths.Line([xc-hd, yc-d], [xc, yc-d]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                      EnLine: new makerjs.paths.Line([xc+cutLine, yc], [xc, yc]),
                      Left: new makerjs.paths.Line([xc, yc], [xc-hd, yc]),
                      BottomArc: new makerjs.paths.Arc([xc-hd, yc],[xc-hd, yc-d], r, true,false),
                      Right: new makerjs.paths.Line([xc-hd, yc-d], [xc, yc-d]),
                      Exline: new makerjs.paths.Line([xc, yc-d], [xc+cutLine, yc-d]),
                  }
            };
          } else if (area == "G") {
            var myUShapeGapH = {
                  paths: {
                      Left: new makerjs.paths.Line([xg, yg], [xg+hd, yg]),
                      BottomArc: new makerjs.paths.Arc([xg+hd, yg],[xg+hd, yg+d], r, true,false),
                      Right: new makerjs.paths.Line([xg+hd, yg+d], [xg, yg+d]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                      EnLine: new makerjs.paths.Line([xg-cutLine, yg], [xg, yg]),
                      Left: new makerjs.paths.Line([xg, yg], [xg+hd, yg]),
                      BottomArc: new makerjs.paths.Arc([xg+hd, yg],[xg+hd, yg+d], r, true,false),
                      Right: new makerjs.paths.Line([xg+hd, yg+d], [xg, yg+d]),
                      Exline: new makerjs.paths.Line([xg, yg+d], [xg-cutLine, yg+d]),
                  }
            };
          } else if (area == "F") {
            var myUShapeGapH = {
                  paths: {
                      Left: new makerjs.paths.Line([xf, yf+r], [xf-hd, yf+r]),
                      BottomArc: new makerjs.paths.Arc([xf-hd, yf+r],[xf-hd, yf-d+r], r, true,false),
                      Right: new makerjs.paths.Line([xf-hd, yf-d+r], [xf, yf-d+r]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                      EnLine: new makerjs.paths.Line([xf+cutLine, yf+r], [xf, yf+r]),
                      Left: new makerjs.paths.Line([xf, yf+r], [xf-hd, yf+r]),
                      BottomArc: new makerjs.paths.Arc([xf-hd, yf+r],[xf-hd, yf-d+r], r, true,false),
                      Right: new makerjs.paths.Line([xf-hd, yf-d+r], [xf, yf-d+r]),
                      Exline: new makerjs.paths.Line([xf, yf-d+r], [xf+cutLine, yf-d+r]),
                  }
            };
          } else if (area == "I") {
            var myUShapeGapH = {
                  paths: {
                      Left: new makerjs.paths.Line([xi, yi], [xi-hd, yi]),
                      BottomArc: new makerjs.paths.Arc([xi-hd, yi],[xi-hd, yi+d], r, true,true),
                      Right: new makerjs.paths.Line([xi-hd, yi+d], [xi, yi+d]),
                  }
            };
            var myUShapeGapHWaterCut = {
                  paths: {
                      EnLine: new makerjs.paths.Line([xi+cutLine, yi], [xi, yi]),
                      Left: new makerjs.paths.Line([xi, yi], [xi-hd, yi]),
                      BottomArc: new makerjs.paths.Arc([xi-hd, yi],[xi-hd, yi+d], r, true,true),
                      Right: new makerjs.paths.Line([xi-hd, yi+d], [xi, yi+d]),
                      Exline: new makerjs.paths.Line([xi, yi+d], [xi+cutLine, yi+d]),
                  }
            };
          }
} 
    
  return [myUShapeGapH,myUShapeGapHWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyUShapeGapHMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatCornerMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var D=inputParam.D,H=inputParam.H,X=inputParam.X,Y=inputParam.Y, myZoom = zoom * 1,
        xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc,
        
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, 
        xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
        x = param.x0, r = param.r, d = param.d, h = param.h,hd=h-r, 
        glassW = outParam.glassW, glassH = outParam.glassH,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
        markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
        d = D*1*myZoom,
   h= H*1*myZoom,
   r=d/2,
     x0 = X*1*myZoom,
     y0 = Y*1*myZoom;
     if(d!==0){
      var TxtD=TxtD="∮"+D;
     }
     if(h!==0){
      var TxtH=H;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
     if(x0!==0){          
      var TxtX=X;
     }
if(glassW*1<glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
 if (area == "A") {
            var myUsgGapAMakerH = {
                  paths: {
                        "HALine0": new makerjs.paths.Line([xa+d+markShift,ya], [xa+d+markShift,ya-h]),
                        "HALine1": new makerjs.paths.Line([xa+r,ya-h], [xa+d+markShiftFour,ya-h]),
                  }
            };
            var myUsgGapAMakerD = {
                  paths: {
                        "DALine0": new makerjs.paths.Line([xa,ya], [xa,ya+markShiftFour]),
                        "DALine1": new makerjs.paths.Line([xa+d,ya], [xa+d,ya+markShiftFour]),
                        "DALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+d, ya+markShiftTwo]),
                  }
            };
              var myUsgGapAMakerX = {
                    paths: {
                          "XALine0": new makerjs.paths.Line([xa - x0, ya + markShift], [xa, ya + markShift]),
                          "XALine1": new makerjs.paths.Line([xa - x0, ya], [xa - x0, ya + markShiftFour]),
                          "XALine2": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
                    }
              };
              makerjs.model.addCaption(myUsgGapAMakerH, TxtH,[xa+d+markShiftFour,ya-h], [xa+d+markShiftFour,ya]);//H文字标注
              makerjs.model.addCaption(myUsgGapAMakerX, TxtX, [xa - x0, ya + markShiftTwo], [xa, ya + markShiftTwo]);//X文字标注
              makerjs.model.addCaption(myUsgGapAMakerD, TxtD, [xa,ya+markShiftFour], [xa+d, ya+markShiftFour]);//D文字标注  
              var markers = [myUsgGapAMakerH,myUsgGapAMakerX,myUsgGapAMakerD]
 } else if (area == "B") {
            var myUsgGapBMakerH = {
                  paths: {
                        "HBLine0": new makerjs.paths.Line([xb+d+markShift,yb], [xb+d+markShift,yb-h]),
                        "HBLine1": new makerjs.paths.Line([xb+r,yb-h], [xb+d+markShiftFour,yb-h]),
                  }
            };
            var myUsgGapBMakerD = {
                  paths: {
                        "DBLine0": new makerjs.paths.Line([xb,yb], [xb,yb+markShiftFour]),
                        "DBLine1": new makerjs.paths.Line([xb+d,yb], [xb+d,yb+markShiftFour]),
                        "DBLine2": new makerjs.paths.Line([xb,yb+markShiftTwo], [xb+d, yb+markShiftTwo]),
                  }
            };
              var myUsgGapBMakerX = {
                    paths: {
                        //   "XBLine0": new makerjs.paths.Line([xb - x0, yb + markShift], [xb, yb + markShift]),
                        //   "XBLine1": new makerjs.paths.Line([xb - x0, yb], [xb - x0, yb + markShiftFour]),
                        //   "XBLine2": new makerjs.paths.Line([xb, yb], [xb, yb + markShiftFour]),
                    }
              };
              makerjs.model.addCaption(myUsgGapBMakerH, TxtH,[xb+d+markShiftFour,yb-h], [xb+d+markShiftFour,yb]);//H文字标注
              makerjs.model.addCaption(myUsgGapBMakerX, TxtX, [xb - x0, yb + markShiftTwo], [xb, yb + markShiftTwo]);//X文字标注
              makerjs.model.addCaption(myUsgGapBMakerD, TxtD, [xb,yb+markShiftFour], [xb+d, yb+markShiftFour]);//D文字标注  
              var markers = [myUsgGapBMakerH,myUsgGapBMakerX,myUsgGapBMakerD]
 } else if (area == "C") {
            var myUsgGapCMakerH = {
                  paths: {
                        "HCLine0": new makerjs.paths.Line([xc-d-markShift,yc], [xc-d-markShift,yc-h]),
                        "HCLine1": new makerjs.paths.Line([xc-r,yc-h], [xc-d-markShiftFour,yc-h]),
                  }
            };
            var myUsgGapCMakerD = {
                  paths: {
                        "DCLine0": new makerjs.paths.Line([xc,yc], [xc,yc+markShiftFour]),
                        "DCLine1": new makerjs.paths.Line([xc-d,yc], [xc-d,yc+markShiftFour]),
                        "DCLine2": new makerjs.paths.Line([xc-d,yc+markShiftTwo], [xc, yc+markShiftTwo]),
                  }
            };
              var myUsgGapCMakerX = {
                    paths: {
                          "XCLine0": new makerjs.paths.Line([xc + x0, yc + markShift], [xc, yc + markShift]),
                          "XCLine1": new makerjs.paths.Line([xc + x0, yc], [xc + x0, yc + markShiftFour]),
                          "XCLine2": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
                    }
              };
              makerjs.model.addCaption(myUsgGapCMakerH, TxtH,[xc-d-markShiftFour,yc-h], [xc-d-markShiftFour,yc]);//H文字标注
              makerjs.model.addCaption(myUsgGapCMakerX, TxtX, [xc, yc + markShiftTwo], [xc+x0, yc + markShiftTwo]);//X文字标注
              makerjs.model.addCaption(myUsgGapCMakerD, TxtD, [xc-d,yc+markShiftFour], [xc, yc+markShiftFour]);//D文字标注  
              var markers = [myUsgGapCMakerH,myUsgGapCMakerX,myUsgGapCMakerD]
 } else if (area == "G") {
            var myUsgGapGMakerH = {
                  paths: {
                        "HGLine0": new makerjs.paths.Line([xg+d+markShift,yg], [xg+d+markShift,yg+h]),
                        "HGLine1": new makerjs.paths.Line([xg+r,yg+h], [xg+d+markShiftFour,yg+h]),
                  }
            };
            var myUsgGapGMakerD = {
                  paths: {
                        "DGLine0": new makerjs.paths.Line([xg,yg], [xg,yg-markShiftFour]),
                        "DGLine1": new makerjs.paths.Line([xg+d,yg], [xg+d,yg-markShiftFour]),
                        "DGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+d, yg-markShiftTwo]),
                  }
            };
              var myUsgGapGMakerX = {
                    paths: {
                          "XGLine0": new makerjs.paths.Line([xg - x0, yg - markShiftTwo], [xg, yg - markShiftTwo]),
                          "XGLine1": new makerjs.paths.Line([xg - x0, yg], [xg - x0, yg - markShiftFour]),
                          "XGLine2": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
                    }
              };
              makerjs.model.addCaption(myUsgGapGMakerH, TxtH, [xg+d+markShiftFour,yg],[xg+d+markShiftFour,yg+h]);//H文字标注
              makerjs.model.addCaption(myUsgGapGMakerX, TxtX, [xg - x0, yg - markShiftFour], [xg, yg - markShiftFour]);//X文字标注
              makerjs.model.addCaption(myUsgGapGMakerD, TxtD, [xg,yg-markShiftFour], [xg+d, yg-markShiftFour]);//D文字标注  
         var markers = [myUsgGapGMakerH,myUsgGapGMakerX,  myUsgGapGMakerD]
 } else if (area == "H") {
            var myUsgGapHMakerH = {
                  paths: {
                        "HHLine0": new makerjs.paths.Line([xh+d+markShift,yh], [xh+d+markShift,yh+h]),
                        "HHLine1": new makerjs.paths.Line([xh+r,yh+h], [xh+d+markShiftFour,yh+h]),
                  }
            };
            var myUsgGapHMakerD = {
                  paths: {
                        "DHLine0": new makerjs.paths.Line([xh,yh], [xh,yh-markShiftFour*2]),
                        "DHLine1": new makerjs.paths.Line([xh+d,yh], [xh+d,yh-markShiftFour*2]),
                        "DHLine2": new makerjs.paths.Line([xh,yh-markShiftFour-markShiftTwo], [xh+d, yh-markShiftFour-markShiftTwo]),
                  }
            };
              var myUsgGapHMakerX = {
                    paths: {
                        //   "XHLine0": new makerjs.paths.Line([xh - x0, yh - markShift], [xh, yh - markShift]),
                        //   "XHLine1": new makerjs.paths.Line([xh - x0, yh], [xh - x0, yh - markShiftFour]),
                        //   "XHLine2": new makerjs.paths.Line([xh, yh], [xh, yh - markShiftFour]),
                    }
              };
              makerjs.model.addCaption(myUsgGapHMakerH, TxtH, [xh+d+markShiftFour,yh],[xh+d+markShiftFour,yh+h]);//H文字标注
              makerjs.model.addCaption(myUsgGapHMakerX, TxtX, [xh - x0, yh - markShiftTwo], [xh, yh - markShiftTwo]);//X文字标注
              makerjs.model.addCaption(myUsgGapHMakerD, TxtD, [xh,yh-markShiftFour*2], [xh+d, yh-markShiftFour*2]);//D文字标注  
         var markers = [myUsgGapHMakerH,myUsgGapHMakerX,  myUsgGapHMakerD]
 } else if (area == "I") {
            var myUsgGapIMakerH = {
                  paths: {
                        "HILine0": new makerjs.paths.Line([xi-d-markShift,yi], [xi-d-markShift,yi+h]),
                        "HILine1": new makerjs.paths.Line([xi-r,yi+h], [xi-d-markShiftFour,yi+h]),
                  }
            };
            var myUsgGapIMakerD = {
                  paths: {
                        "DILine0": new makerjs.paths.Line([xi,yi], [xi,yi-markShiftFour]),
                        "DILine1": new makerjs.paths.Line([xi-d,yi], [xi-d,yi-markShiftFour]),
                        "DILine2": new makerjs.paths.Line([xi-d,yi-markShiftTwo], [xi, yi-markShiftTwo]),
                  }
            };
              var myUsgGapIMakerX = {
                    paths: {
                          "XILine0": new makerjs.paths.Line([xi + x0, yi - markShiftTwo], [xi, yi - markShiftTwo]),
                          "XILine1": new makerjs.paths.Line([xi + x0, yi], [xi + x0, yi - markShiftFour]),
                          "XILine2": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
                    }
              };
              makerjs.model.addCaption(myUsgGapIMakerH, TxtH, [xi-d-markShiftFour,yi],[xi-d-markShiftFour,yi+h]);//H文字标注
              makerjs.model.addCaption(myUsgGapIMakerX, TxtX, [xi, yi - markShiftFour], [xi+x0, yi - markShiftFour]);//X文字标注
              makerjs.model.addCaption(myUsgGapIMakerD, TxtD, [xi-d,yi-markShiftFour], [xi, yi-markShiftFour]);//D文字标注  
         var markers = [myUsgGapIMakerH,myUsgGapIMakerX,myUsgGapIMakerD]
}

}else{
      console.log("短边在X轴￥￥￥￥￥");

if (area == "A") {
            var myUsgGapAMakerH = {
                  paths: {
                        "HALine0": new makerjs.paths.Line([xa,ya+markShift], [xa+h,ya+markShift]),
                        "HALine1": new makerjs.paths.Line([xa+h,ya-d], [xa+h,ya+markShiftFour]),
                  }
            };
            var myUsgGapAMakerD = {
                  paths: {
                        // "DALine0": new makerjs.paths.Line([xa,ya], [xa,ya+markShiftFour]),
                        // "DALine1": new makerjs.paths.Line([xa+d,ya], [xa+d,ya+markShiftFour]),
                        "DALine2": new makerjs.paths.Line([xa+markShift,ya-d], [xa+markShift, ya]),
                  }
            };
              var myUsgGapAMakerY = {
                    paths: {
                          "YALine0": new makerjs.paths.Line([xa - markShiftFour, ya], [xa, ya]),
                          "YALine1": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya + y0]),
                          "YALine2": new makerjs.paths.Line([xa - markShiftFour, ya+y0], [xa, ya+y0]),
                    }
              };
              makerjs.model.addCaption(myUsgGapAMakerH, TxtH,[xa,ya+markShiftThree], [xa+h,ya+markShiftThree]);//H文字标注
              makerjs.model.addCaption(myUsgGapAMakerY, TxtY, [xa - markShiftFour, ya], [xa - markShiftFour, ya + y0]);//Y文字标注
              makerjs.model.addCaption(myUsgGapAMakerD, TxtD, [xa+markShiftThree,ya-d], [xa+markShiftThree, ya]);//D文字标注  
              var markers = [myUsgGapAMakerH,myUsgGapAMakerY,myUsgGapAMakerD]
 } else if (area == "D") {
      var myUsgGapDMakerH = {
            paths: {
                  "HDLine0": new makerjs.paths.Line([xd,yd+markShift+r], [xd+h,yd+markShift+r]),
                  "HDLine1": new makerjs.paths.Line([xd+h,yd-d+r], [xd+h,yd+markShiftFour+r]),
            }
      };
      var myUsgGapDMakerD = {
            paths: {
                  // "DDLine0": new makerjs.paths.Line([xd,yd], [xd,yd+markShiftFour]),
                  // "DDLine1": new makerjs.paths.Line([xd+d,yd], [xd+d,yd+markShiftFour]),
                  "DDLine2": new makerjs.paths.Line([xd+markShift,yd-d+r], [xd+markShift, yd+r]),
            }
      };
        var myUsgGapDMakerY = {
              paths: {
                    "YDLine0": new makerjs.paths.Line([xd - markShiftFour, yd+r], [xd, yd+r]),
                    "YDLine1": new makerjs.paths.Line([xd - markShiftTwo, yd+r], [xd - markShiftTwo, yd + y0+r]),
                    "YDLine2": new makerjs.paths.Line([xd - markShiftFour, yd+y0+r], [xd, yd+y0+r]),
              }
        };
        makerjs.model.addCaption(myUsgGapDMakerH, TxtH,[xd,yd+markShiftThree+r], [xd+h,yd+markShiftThree+r]);//H文字标注
        makerjs.model.addCaption(myUsgGapDMakerY, TxtY, [xd - markShiftFour, yd+r], [xd - markShiftFour, yd + y0+r]);//Y文字标注
        makerjs.model.addCaption(myUsgGapDMakerD, TxtD, [xd+markShiftThree,yd-d+r], [xd+markShiftThree, yd+r]);//D文字标注  
        var markers = [myUsgGapDMakerH,myUsgGapDMakerY,myUsgGapDMakerD]
 } else if (area == "C") {
      var myUsgGapCMakerH = {
            paths: {
                  "HCLine0": new makerjs.paths.Line([xc,yc+markShift], [xc-h,yc+markShift]),
                  "HCLine1": new makerjs.paths.Line([xc-h,yc-d], [xc-h,yc+markShiftFour]),
            }
      };
      var myUsgGapCMakerD = {
            paths: {
                  // "DCLine0": new makerjs.paths.Line([xc,yc], [xc,yc+markShiftFour]),
                  // "DCLine1": new makerjs.paths.Line([xc+d,yc], [xc+d,yc+markShiftFour]),
                  "DCLine2": new makerjs.paths.Line([xc-markShift,yc-d], [xc-markShift, yc]),
            }
      };
        var myUsgGapCMakerY = {
              paths: {
                    "YCLine0": new makerjs.paths.Line([xc + markShiftFour, yc], [xc, yc]),
                    "YCLine1": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc + y0]),
                    "YCLine2": new makerjs.paths.Line([xc + markShiftFour, yc+y0], [xc, yc+y0]),
              }
        };
        makerjs.model.addCaption(myUsgGapCMakerH, TxtH,[xc-h,yc+markShiftThree], [xc,yc+markShiftThree]);//H文字标注
        makerjs.model.addCaption(myUsgGapCMakerY, TxtY, [xc + markShiftFour, yc], [xc + markShiftFour, yc + y0]);//Y文字标注
        makerjs.model.addCaption(myUsgGapCMakerD, TxtD, [xc-markShiftThree,yc-d], [xc-markShiftThree, yc]);//D文字标注  
        var markers = [myUsgGapCMakerH,myUsgGapCMakerY,myUsgGapCMakerD]
 } else if (area == "G") {
      var myUsgGapGMakerH = {
            paths: {
                  "HGLine0": new makerjs.paths.Line([xg,yg-markShift], [xg+h,yg-markShift]),
                  "HGLine1": new makerjs.paths.Line([xg+h,yg+d], [xg+h,yg-markShiftFour]),
            }
      };
      var myUsgGapGMakerD = {
            paths: {
                  // "DGLine0": new makerjs.paths.Line([xg,yg], [xg,yg+markShiftFour]),
                  // "DGLine1": new makerjs.paths.Line([xg+d,yg], [xg+d,yg+markShiftFour]),
                  "DGLine2": new makerjs.paths.Line([xg+markShift,yg+d], [xg+markShift, yg]),
            }
      };
        var myUsgGapGMakerY = {
              paths: {
                    "YGLine0": new makerjs.paths.Line([xg - markShiftFour, yg], [xg, yg]),
                    "YGLine1": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg - y0]),
                    "YGLine2": new makerjs.paths.Line([xg - markShiftFour, yg-y0], [xg, yg-y0]),
              }
        };
        makerjs.model.addCaption(myUsgGapGMakerH, TxtH,[xg,yg-markShiftThree], [xg+h,yg-markShiftThree]);//H文字标注
        makerjs.model.addCaption(myUsgGapGMakerY, TxtY, [xg - markShiftFour, yg - y0], [xg - markShiftFour, yg]);//Y文字标注
        makerjs.model.addCaption(myUsgGapGMakerD, TxtD, [xg+markShiftThree,yg], [xg+markShiftThree, yg+d]);//D文字标注  
        var markers = [myUsgGapGMakerH,myUsgGapGMakerY,myUsgGapGMakerD]
 } else if (area == "F") {
      var myUsgGapFMakerH = {
            paths: {
                  "HFLine0": new makerjs.paths.Line([xf,yf+markShift+r], [xf-h,yf+markShift+r]),
                  "HFLine1": new makerjs.paths.Line([xf-h,yf-d+r], [xf-h,yf+markShiftFour+r]),
            }
      };
      var myUsgGapFMakerD = {
            paths: {
                  // "FFLine0": new makerjs.paths.Line([xf,yf], [xf,yf+markShiftFour]),
                  // "DFLine1": new makerjs.paths.Line([xf+d,yf], [xf+d,yf+markShiftFour]),
                  "DFLine2": new makerjs.paths.Line([xf-markShift,yf-d+r], [xf-markShift, yf+r]),
            }
      };
        var myUsgGapFMakerY = {
              paths: {
                    "YFLine0": new makerjs.paths.Line([xf + markShiftFour, yf+r], [xf, yf+r]),
                    "YFLine1": new makerjs.paths.Line([xf + markShiftTwo, yf+r], [xf + markShiftTwo, yf + y0+r]),
                    "YFLine2": new makerjs.paths.Line([xf + markShiftFour, yf+y0+r], [xf, yf+y0+r]),
              }
        };
        makerjs.model.addCaption(myUsgGapFMakerH, TxtH,[xf-h,yf+markShiftThree+r], [xf,yf+markShiftThree+r]);//H文字标注
        makerjs.model.addCaption(myUsgGapFMakerY, TxtY, [xf + markShiftFour, yf+r], [xf + markShiftFour, yf + y0+r]);//Y文字标注
        makerjs.model.addCaption(myUsgGapFMakerD, TxtD, [xf-markShiftThree,yf-d+r], [xf-markShiftThree, yf+r]);//D文字标注  
        var markers = [myUsgGapFMakerH,myUsgGapFMakerY,myUsgGapFMakerD]
 } else if (area == "I") {
      var myUsgGapIMakerH = {
            paths: {
                  "HILine0": new makerjs.paths.Line([xi,yi-markShift], [xi-h,yi-markShift]),
                  "HILine1": new makerjs.paths.Line([xi-h,yi+d], [xi-h,yi-markShiftFour]),
            }
      };
      var myUsgGapIMakerD = {
            paths: {
                  // "DILine0": new makerjs.paths.Line([xi,yi], [xi,yi+markShiftFour]),
                  // "DILine1": new makerjs.paths.Line([xi+d,yi], [xi+d,yi+markShiftFour]),
                  "DILine2": new makerjs.paths.Line([xi-markShift,yi+d], [xi-markShift, yi]),
            }
      };
        var myUsgGapIMakerY = {
              paths: {
                    "YILine0": new makerjs.paths.Line([xi + markShiftFour, yi], [xi, yi]),
                    "YILine1": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi - y0]),
                    "YILine2": new makerjs.paths.Line([xi + markShiftFour, yi-y0], [xi, yi-y0]),
              }
        };
        makerjs.model.addCaption(myUsgGapIMakerH, TxtH,[xi-h,yi-markShiftThree], [xi,yi-markShiftThree]);//H文字标注
        makerjs.model.addCaption(myUsgGapIMakerY, TxtY, [xi + markShiftFour, yi - y0], [xi + markShiftFour, yi]);//Y文字标注
        makerjs.model.addCaption(myUsgGapIMakerD, TxtD, [xi-markShiftThree,yi], [xi-markShiftThree, yi+d]);//D文字标注  
        var markers = [myUsgGapIMakerH,myUsgGapIMakerY,myUsgGapIMakerD]
}      
      
}
  
  console.log("markers||||||||||||||||||=", markers)
  return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function UShapeGapH(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
  var frame = outParam.shapeName;
      console.log("outParam==", outParam)
      console.log("model==", model)
      console.log("inputParam==", inputParam)
      console.log("outParam.shapeName==////////", outParam.shapeName)
      if (typeof (frame) == "undefined") {
            var D=inputParam.D,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
            plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
                  glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  d = D*1*myZoom,
   h= H*1*myZoom,
   r=d/2,
     x0 = X*1*myZoom,
     y0 = Y*1*myZoom;
     if(plate.models===undefined||plate.models===""){
      console.log("1111111111111111");
      plate.models={};
              }        
              if(cutPlate.models===undefined||cutPlate.models===""){
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models={};
              }
              if(markers.models===undefined||markers.models===""){            
                  console.log("333333333333");
                  markers.models={};
              }
     if(d!==0){
      var TxtD=TxtD="∮"+D;
     }
     if(h!==0){
      var TxtH=H;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
     if(x0!==0){          
      var TxtX=X;
     }
      } else {
            var D=inputParam.D,W=inputParam.W,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
            plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
                  glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  d = D*1*myZoom,
   w= W*1*myZoom,
   r=d/2,
     x0 = X*1*myZoom,
     y0 = Y*1*myZoom;
     if(plate.models===undefined||plate.models===""){
      console.log("1111111111111111");
      plate.models={};
              }        
              if(cutPlate.models===undefined||cutPlate.models===""){
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models={};
              }
              if(markers.models===undefined||markers.models===""){            
                  console.log("333333333333");
                  markers.models={};
              }
     if(d!==0){
      var TxtD=TxtD="∮"+D;
     }
     if(w!==0){
      var TxtW=W;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
     if(x0!==0){          
      var TxtX=X;
     }
      }
      if (frame == "Rectangle") {
            console.log("frame==undefined||||*****")
            //在A区域 计算孔的位置       
            var xa = x0, ya = glassH * 1 - y0,
                  //B区域//只有Y标注没有X标注 
                  xb = glassW * 1 / 2, yb = glassH * 1 - y0,
                  //C区域
                  xc = glassW * 1 - x0, yc = glassH * 1 - y0,
                  //在G区域 计算孔的位置
                  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
                  xg = x0, yg = y0,
                  //在H区域 计算孔的位置
                  //只标注Y
                  xh = glassW * 1 / 2, yh = y0,
                  //在I区域 计算孔的位置
                  xi = glassW * 1 - x0, yi = y0;
            var OffsetParam = {};
      } else if (frame == "IsoscelesTrapezoid") {
    
      } else if (frame == "RightAngledTrapezoid") {d
    
      } else if (frame == "OtherTrapezoidsA") {
    
      } else if (frame == "OtherTrapezoidsB") {
    
      } else if (frame == "ParallelogramA") {
    
    
      } else if (frame == "ParallelogramB") {
    
      }
      // 坐标参数
      var paramCoordinate = { x0,d,h,r,cutLine,cutFilletRadius,xa, ya, xb, yb, xd, yd, xf, yf, xc, yc, xg, yg, xh, yh, xi, yi,glassW,glassH};
      const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
      var areaPoint = "";
      console.log("//角7、地弹簧3 ------", allKeys)
      if (allKeys[0] == frame) {
            allKeys.shift();//去掉数组第一个元素
      }
      console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
      switch (area) {
            case "1": areaPoint = "A"; break;
            case "2": areaPoint = "B"; break;
            case "3": areaPoint = "C"; break;
            case "4": areaPoint = "D"; break;
            case "6": areaPoint = "F"; break;
            case "7": areaPoint = "G"; break;
            case "8": areaPoint = "H"; break;
            case "9": areaPoint = "I"; break;
      }
      /**
      * 画图
      * 
      */
      var ObjName = "myUShapeGapH" + areaPoint;
      var ObjNameMmyUShapeGapH = "myUShapeGapH" + areaPoint + "Mark";//角标记
      ObjName = creatmyUShapeGapH(areaPoint, paramCoordinate);//图形
      console.log("ObjName===|||||||||", ObjName);
      ObjNameMmyUShapeGapH = creatmyUShapeGapHMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
      console.log("ObjNameMmyUShapeGapH===|||||||||角标注", ObjNameMmyUShapeGapH);
      console.log("cutPlate.models====************", cutPlate.models),
            console.log("plate.models====**************", plate.models),
            console.log("markers.models====*************", markers.models),
         // myUsgGapAMakerH,myUsgGapAMakerX,myUsgGapAMakerD
            cutPlate.models["TypeGapes_myUShapeGapH" + areaPoint + myHolesNum] = ObjName[1];
      plate.models["TypeGapes_myUShapeGapH" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGapes_myUShapeGapH" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGapes_myUShapeGapHH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyUShapeGapH[0];
      markers.models["TypeGapes_myUShapeGapHX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyUShapeGapH[1];
      markers.models["TypeGapes_myUShapeGapHD" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyUShapeGapH[2];
myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default UShapeGapH;